import { ReactElement } from 'react';

interface Props {
  title: string;
  description: string;
  icon: ReactElement;
  align?: string;
  last?: boolean;
}

const FeatureRow: React.FC<Props> = ({
  title,
  description,
  icon,
  align = 'left',
  last = false,
}) => {
  return (
    <div
      className={`flex flex-col items-center pb-10 mb-10 sm:flex-row xl:px-20 ${
        last ? 'border-b-0' : 'border-b border-gray-200'
      }`}
    >
      <div
        className={`inline-flex items-center justify-center flex-shrink-0 w-20 h-20 text-summer-green-700 bg-summer-green-100 border border-summer-green-300 rounded-full sm:w-28 sm:h-28 sm:mr-10 mb-6 sm:mb-0 ${
          align === 'right' ? 'sm:hidden' : ''
        }`}
      >
        {icon}
      </div>
      <div className={`flex-grow text-center sm:text-left`}>
        <h2 className="mb-2 text-lg font-medium text-san-juan-blue-500 title-font">
          {title}
        </h2>
        <p className="text-base leading-relaxed">{description}</p>
      </div>
      <div
        className={`inline-flex items-center justify-center flex-shrink-0 w-20 h-20 text-summer-green-700 bg-summer-green-100 border border-summer-green-300 rounded-full sm:w-28 sm:h-28 sm:ml-10 ${
          align === 'right' ? 'hidden sm:inline-flex' : 'hidden'
        }`}
      >
        {icon}
      </div>
    </div>
  );
};

export default FeatureRow;
